<template>
	<div>
		<label class="d-block mb-1">
			<input
				type="radio"
				name="display-select"
				v-model="selected"
				:value="1"
				@change="displayChanged"
			/>
			<v-chip dark color="#3b3939" type="button" class="button">
				<v-icon class="ml-1">fas fa-tv</v-icon>
				{{ this.$t('toolbar.game_modes.game') }}
			</v-chip>
		</label>
		<label class="d-block mb-1">
			<input
				type="radio"
				name="display-select"
				v-model="selected"
				:value="2"
				@change="displayChanged"
			/>
			<v-chip dark color="#3b3939" type="button" class="button">
				<v-icon class="ml-1">far fa-edit</v-icon>
				{{ this.$t('toolbar.game_modes.edit') }}
			</v-chip>
		</label>
		<label class="d-block mb-1">
			<input
				type="radio"
				name="display-select"
				v-model="selected"
				:value="3"
				@change="displayChanged"
			/>
			<v-chip dark color="#3b3939" type="button" class="button">
				<v-icon class="ml-1">fas fa-table</v-icon>
				{{ this.$t('toolbar.game_modes.combined') }}
			</v-chip>
		</label>
	</div>
</template>

<script>
export default {
	name: "game-display-select",
	props: [],
	components: {},
	data() {
		return {
			selected: 3
		};
	},
	computed: {
		currentDisplay(){
			return this.$store.getters.gameDisplay;
		}
	},
	methods: {
		displayChanged() {
			this.$emit("display-changed", this.selected);
		}
	},
	created() {
		if(this.currentDisplay){
			this.selected = this.currentDisplay;
		}
		else{
			this.selected = 3;
		}
	},
	mounted() {},
	updated() {},
	destroyed() {}
};
</script>

<style scoped>
[type="radio"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

[type="radio"] + .button {
  cursor: pointer;
}

/* CHECKED STYLES */
[type="radio"]:not(:checked) + .button {
  background-color: rgb(213, 213, 213) !important;
  color: black;
}
[type="radio"]:checked + .button {
  background-color: rgb(59, 57, 57) !important;
  color: white;
}
</style>
